<p-breadcrumb
  [model]="items"
  (onItemClick)="handleItemClick($event)"
  styleClass="bg-transparent border-none p-0"
></p-breadcrumb>
